<template>
  <div>
    <!--TODO get rid of this paddingrow please-->
    <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
           v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
           fluid>
      <v-col md="8" sm="10" xs="12">
        <fin-data-table :headers="headers" :mobile-breakpoint="Number.MAX_SAFE_INTEGER" :resolver="[instrument]"
                        hide-default-footer hide-default-header transparent disable-row-hover/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"
import FinDataTable from "@/components/common/DataTable/FinDataTable"

export default {
  name: 'fin-etf-page-portfolio',
  components: {FinDataTable},
  props: {
    instrument: {}
  },
  data() {
    return {
      headers: TablePresets.createEtfProfilePortfolioDataHeaders(this.instrument)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
